import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 17,
	viewBox: "0 0 11 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 1L3.8125 7L1 4.27273",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCheckIcon;
